export default function initToggle() {
  const toggleButtons = document.querySelectorAll("[data-toggle]");
  if (!toggleButtons.length) {
    return;
  }

  toggleButtons.forEach((button) => {
    button.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        button.classList.toggle("is-open");
        document
          .querySelector(`#${button.dataset.toggle}`)
          .classList.toggle("hidden");
      },
      false
    );
  });
}
